import { API_URL } from '../config';

export const fetchLaunchConfig = async () => {
    try {
        const response = await fetch(`${API_URL}/launch-config`);
        if (!response.ok) {
            throw new Error('Failed to fetch launch config');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching launch config:', error);
        // Return default launched mode if fetch fails
        return { isLaunched: true, betaModeMessage: '' };
    }
};
